import * as React from 'react';

/**
 * Tracks the width of a toolbar (or any) element with ResizeObserver.
 * When `element` is null or reports zero width, uses `fallbackWidth` (e.g. viewport width).
 */
export function useToolbarWidth(element: HTMLElement | null, fallbackWidth: number): number {
    const safeFallback = Math.max(0, Math.round(fallbackWidth));
    const [width, setWidth] = React.useState(safeFallback);

    React.useLayoutEffect(() => {
        if (!element) return;

        const observer = new ResizeObserver(entries => {
            const entry = entries[0];
            if (!entry) return;
            const rounded = Math.round(entry.contentRect.width);
            setWidth(rounded > 0 ? rounded : safeFallback);
        });

        observer.observe(element);
        return () => observer.disconnect();
    }, [element, safeFallback]);

    return element ? width : safeFallback;
}
